/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const getStringIndex = (locationPath: string[], findString: string): number => locationPath.findIndex((element: string): boolean => element.includes(findString));
export const reverseTrueOrFalseSubmission = (trueOrFalse: string): string => (trueOrFalse === 'true' ? 'false' : 'true');
// convert 2022-02-08T13:00:00.000Z to dd/mm/yyyy
export const convertStringToDate = (dateIn: string): string => {
    if (dateIn) {
      const convertDate = new Date(dateIn);
      return `${convertDate?.getDate()}/${convertDate?.getMonth() + 1}/${convertDate?.getFullYear()}` || '';
    }
    return '';
};
// adding all date fields of all react forms and make sure partial form can handle date fields correctly
const dateTypeField = ['DOB', 'DAOffence', 'DOBOptional', 'DateToPay', 'DOBSomeoneElse', 'DateSellOrDispose', 'DOBSoldDisposed', 'DOBYourDetails', 'OFFENCE_FIND_OUT_DATE', 'firstInstalmentDate', 'OFFENCE_DATE', 'DOBFineholderDetails', 'DOBYourDetailsIndividual', 'HEARING_DATE', 'personUnawareFindOutDate'];
const dontOverrideStep3IfNotEmpty = ['Has7DayNotice', 'ActionsTakenOnFine', 'HasLinkBwFVSAndFines', 'HasEvidenceToSupport'];
export const setFormDataValues = (partialFormApi: any, formikObject: any, formikValuesRef: any, keyName: string): void => {
  Object.keys(partialFormApi).forEach((key) => {
    if (key in partialFormApi) {
      if (typeof partialFormApi[key] === 'object' && partialFormApi[key] && partialFormApi[key].length > 0 && !(partialFormApi[key] instanceof Date)) {
        setFormDataValues(partialFormApi[key], formikObject[key], formikValuesRef, `${keyName}.${key}`);
      } else if (dateTypeField.includes(key) && partialFormApi[key]) { // treat date fields differently
        formikValuesRef.current.setFieldValue(`${keyName}.${key}`, new Date(partialFormApi[key]));
      } else {
        if ((dontOverrideStep3IfNotEmpty.includes(keyName) || dontOverrideStep3IfNotEmpty.includes(key)) && formikObject[key]) {
          return;
        }
        formikValuesRef.current.setFieldValue(`${keyName}.${key}`, partialFormApi[key]);
      }
    }
  });
};

export const setCurrentFormikValues = (partialFormApi: any, formikObject: any, formikValuesRef: any, keyName?: string): void => {
  Object.keys(partialFormApi).forEach((key) => {
    if (key in partialFormApi) {
      if (typeof partialFormApi[key] === 'object' && partialFormApi[key]) {
        setCurrentFormikValues(partialFormApi[key], formikObject[key], formikValuesRef, keyName ? `${keyName}.${key}` : key);
      } else if (dateTypeField.includes(key) && partialFormApi[key]) {
        formikValuesRef.current.setFieldValue(key, new Date(partialFormApi[key]));
      } else if (keyName) {
        if (dontOverrideStep3IfNotEmpty.includes(keyName) && (formikObject[key] || formikObject[0] === 'None')) {
          return;
        }
        if (key === 'NoActionsTaken' && formikObject.ActionsTakenOnFine && formikObject.ActionsTakenOnFine.length !== 0) {
          return;
        }
        formikValuesRef.current.setFieldValue(`${keyName}.${key}`, partialFormApi[key]);
      } else {
        if (dontOverrideStep3IfNotEmpty.includes(key) && (formikObject[key] || formikObject[0] === 'None')) {
          return;
        }
        if (key === 'NoActionsTaken' && formikObject.ActionsTakenOnFine && formikObject.ActionsTakenOnFine.length !== 0) {
          return;
        }
        formikValuesRef.current.setFieldValue(key, partialFormApi[key]);
      }
    }
  });
};

export const getFutureDateAfterNMonth = (futureMonth: number): Date => {
  const today = new Date();
  return new Date(today.setMonth(today.getMonth() + futureMonth));
};

export const getDateForValidateDebtor = (receivedDates: string): string => {
  const dateObj = receivedDates.split('/');
  const specificedDateString = `${dateObj[2]}-${dateObj[1]}-${dateObj[0]}`;
  return specificedDateString;
};

export const bytesToMBSize = (bytes: number): string => {
  if (bytes === 0) return 'n/a';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString(), 10);
  if (i === 0) return `${bytes}`;
  return `${(bytes / (1024 ** i)).toFixed(0)}`;
};
